import { render, staticRenderFns } from "./bc-nen-certificate.vue?vue&type=template&id=0d71881e&"
import script from "./bc-nen-certificate.vue?vue&type=script&lang=js&"
export * from "./bc-nen-certificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports